import { MARKET_INDICES_REFRESH } from 'store/mutation-types'
import { MARKET_TYPE, TRADING_STATUS } from 'const/stock'
import { fetchStockMarketIndices } from 'apis/stock'

const state = { marketIndices: {} }

const getters = {
  marketIndices: state => state.marketIndices.indices || [],
  marketStatus: state => {
    return {
      CN: state.marketIndices.marketStatusCN,
      HK: state.marketIndices.marketStatusHK,
      US: state.marketIndices.marketStatusUS,
      UK: state.marketIndices.marketStatusUK
    }
  },
  hkMarketOpen: state =>
    state.marketIndices.tradingStatusHK === TRADING_STATUS.TRADING,
  hkMarketAuction: state =>
    state.marketIndices.tradingStatusHK === TRADING_STATUS.PRE_TRADING ||
    state.marketIndices.tradingStatusHK === TRADING_STATUS.POST_TRADING,
  cnMarketOpen: state =>
    state.marketIndices.tradingStatusCN === TRADING_STATUS.TRADING,
  usMarketOpen: state =>
    state.marketIndices.tradingStatusUS === TRADING_STATUS.TRADING,
  ukMarketOpen: state =>
    state.marketIndices.tradingStatusUK === TRADING_STATUS.TRADING,
  usHourTrading: state =>
    [TRADING_STATUS.PRE_TRADING, TRADING_STATUS.POST_TRADING].includes(
      state.marketIndices.tradingStatusUS
    ),
  usTradingStatus: state => state.marketIndices.tradingStatusUS,
  hkTradingStatus: state => state.marketIndices.tradingStatusHK,
  noMarketOpen: (state, getters) =>
    !getters.hkMarketOpen && !getters.cnMarketOpen && !getters.usMarketOpen
}

const mutations = {
  [MARKET_INDICES_REFRESH](state, newIndices) {
    state.marketIndices = newIndices
  }
}

const actions = {
  refreshIndices({ commit }) {
    // 不从ALL/indices，因为没有期权
    fetchStockMarketIndices({
      market: MARKET_TYPE.ALL,
      configIndices: true
    }).then(response => {
      // remove UK
      if (response.data.indices) {
        response.data.indices = response.data.indices.filter(t => {
          return t.market !== MARKET_TYPE.UK
        })
      }
      commit(MARKET_INDICES_REFRESH, response.data)
    })
  }
}

export default { state, getters, mutations, actions }
